<div class="loading-root" (mousewheel)="$event.preventDefault()">
    <div>
        <mat-spinner></mat-spinner>
        <h1>
            {{ text }}
        </h1>
    </div>
</div>
